import type { EntityValidationRules } from "../services/validationService";
import Enum from "./enum";

export default class Municipality extends Enum {
  regionId: string;
  internalIdent: string;
}

export const MunicipalityValidationRules: EntityValidationRules<Municipality> = {
  name: {
    required: true,
  },
  regionId: {
    required: true,
  },
  internalIdent: {
    required: true,
  },
};
